import { render, staticRenderFns } from "./Onboarding.vue?vue&type=template&id=1f83c21f&scoped=true"
import script from "./Onboarding.vue?vue&type=script&lang=js"
export * from "./Onboarding.vue?vue&type=script&lang=js"
import style0 from "./Onboarding.vue?vue&type=style&index=0&id=1f83c21f&prod&lang=scss&scoped=true"
import style1 from "./Onboarding.vue?vue&type=style&index=1&id=1f83c21f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f83c21f",
  null
  
)

export default component.exports